import { Session } from '@pickleballinc/lib/session';
import clsx from 'clsx';

type Sizes = 'sm' | 'md';

interface PlayerStatusProps {
  status?: string;
  title: string;
  statusSize?: Sizes;
  user?: Session;
  proLevel?: number | undefined;
}

export function PlayerStatus({
  status,
  title,
  statusSize = 'sm',
  user,
  proLevel,
}: PlayerStatusProps) {
  return (
    <>
      <div className='hidden flex-col items-center justify-center p-6 sm:flex'>
        <div
          className={clsx(
            'mb-2 text-gray-600',
            statusSize === 'sm' ? 'text-sm' : 'text-base font-medium'
          )}
        >
          {title}
        </div>
        <div
          className={clsx(
            'font-semibold text-gray-900',
            statusSize === 'sm' ? 'text-3xl' : 'text-4xl',
            !user?.token && Number(proLevel) !== 5 && 'blur'
          )}
        >
          {status}
        </div>
      </div>
      <div className='flex items-center justify-between p-4 sm:hidden'>
        <div className='text-sm text-gray-600'>{title}</div>
        <div
          className={clsx(
            'text-xl font-bold text-gray-900',
            !user?.token && Number(proLevel) !== 5 && 'blur'
          )}
        >
          {status}
        </div>
      </div>
    </>
  );
}
